import { errorSnackbar } from '@/core/service/utils'

export default {
  data: () => ({
    isLoadingAutoCompleteTipoContratos: false,
    searchTextTipoContratos: null,
  }),

  methods: {
    searchAutoCompleteTiposContratos() {
      clearTimeout(this.debounce)
      const vm = this
      this.debounce = setTimeout(() => {
        if (vm.searchTextTipoContratos === null || vm.searchTextTipoContratos.length === 0) {
          vm.searchTextTiposContrados('')
          return
        }
        
        vm.searchTextTiposContrados(vm.searchTextTipoContratos)
      }, 600)
    },

    searchTextTiposContrados (val) {
      this.isLoadingAutoCompleteTipoContratos = true
      this.getTypesContrato({ 
        _filter: { "Chips:iccid_ilike":`${val}%` }
      })
      .catch(err => {
        errorSnackbar(err.error)
      })
      .finally(() => this.isLoadingAutoCompleteTipoContratos = false)
    }
  }
}